import axiosServices from "../utils/axios";
import { convertToCamelCase } from "../utils/code-utils";

import type { JobTimelineData } from "../utils/types/timeline";

interface FetchApiResponce {
  data: any[];
}

export const fetchTimeline = async ({
  version,
  page,
  pageSize,
  companyId,
  startDate,
  endDate,
  agentId,
  q,
  
}: {
  version?: string;
  page?: number;
  pageSize?: number;
  companyId?: string;
  startDate?: string;
  endDate?: string;
  agentId?: string;
  q?: string;
}) => {
  const params: Record<string, any> = {};
  if (version) params.version = version;
  page = page ?? 0;
  pageSize = pageSize ?? 25;
  if (pageSize) {
    params.page = page;
    params.limit = pageSize;
  }
  if (companyId) params.company_id = companyId;
  if (startDate) params.start_date = startDate;
  if (endDate) params.end_date = endDate;
  if (agentId) params.agent_id = agentId;
  if (q) params.q = q;
  const responce = await axiosServices.get<FetchApiResponce>("/timeline", {
    params,
  });
  return {
    data: convertToCamelCase<JobTimelineData[]>(responce.data.data),
    total: (responce.data as any).total ?? responce.data.data.length,
  };
};
